<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
  @import './style/base.less';
  @import './style/helpers.less';
</style>



// WEBPACK FOOTER //
// src/app.vue